import { useState, useEffect } from 'react'
import { getUserInfo, setUserInfo } from '@/utils'
import { userService } from '@/services/amai';
import closex from '@/assets/icons/close-x.svg'
import HI from '@/assets/images/HIS.png'
import Dou from '@/assets/icons/dou.svg'
import { useAliyunCaptcha } from '@/hooks/useAliyunCaptcha';
import {
  WelcomeOverlay,
  WelcomeContainer,
  WelcomeLeftPanel,
  WelcomeRightPanel,
  HiIconWrapper,
  WelcomeText,
  BrandName,
  InfinityBg,
  WelcomeHeading,
  WelcomeSubtitle,
  GiftText,
  BtnWrapper,
  BtnContainer,
  BtnBg,
  BtnLabel,
  WelcomeCloseIcon,
  WelcomeDou,
  WelcomeDouWrapper,
  DouText,
  DouMlText
} from './welcome.styles'
import { message } from 'antd';


interface WelcomeProps {
  onClose: () => void
}

function ClaimedView({ count }: { count: number }) {
  return (
    <WelcomeDouWrapper>
      <WelcomeDou>
        <img src={Dou} alt="" />
        <DouText>领取成功</DouText>
        <DouMlText>米粒值+{count}</DouMlText>
      </WelcomeDou>
    </WelcomeDouWrapper>
  )
}

function GiftView({ onClose, onClaim, loading }: { onClose: () => void; onClaim: () => void; loading?: boolean }) {
  return (
    <WelcomeContainer>
      <WelcomeLeftPanel>
        <HiIconWrapper>
          <img src={HI} alt="" />
        </HiIconWrapper>
        <WelcomeText>欢迎来到</WelcomeText>
        <BrandName>界墨AI</BrandName>
        <InfinityBg />
      </WelcomeLeftPanel>
      <WelcomeRightPanel>
        <WelcomeHeading>在这里</WelcomeHeading>
        <WelcomeSubtitle>让想法轻松成为好作品</WelcomeSubtitle>
        <GiftText>领取新人礼包，开启AI创作吧！</GiftText>
        <BtnWrapper>
          <BtnContainer>
            <BtnBg />
            <BtnLabel onClick={loading ? undefined : onClaim} style={{ opacity: loading ? 0.6 : 1, cursor: loading ? 'not-allowed' : 'pointer' }}>
              {loading ? '加载中...' : '立即领取'}
            </BtnLabel>
          </BtnContainer>
        </BtnWrapper>
        <WelcomeCloseIcon src={closex} alt="" width={18} height={18} onClick={onClose} />
      </WelcomeRightPanel>
    </WelcomeContainer>
  )
}

export default function Welcome({ onClose }: WelcomeProps) {
  const [claimed, setClaimed] = useState(false)
  const [count,setCount] = useState(0)
  const [loading, setLoading] = useState(false)
  const showGift = !!getUserInfo()?.show_new_user_gift
  const { verify } = useAliyunCaptcha()

  const handleSave = async () => {
    setLoading(true)
    try{
      const res = await verify(param => userService.getNewcomerPack(param))
      if(res.data?.claim_credits){
        setCount(res.data.claim_credits / 10)
      }
      setUserInfo({ ...getUserInfo(), show_new_user_gift: false })
      setClaimed(true)
    }catch(error: any){
      if(error?.message === 'user_cancel') return
      message.error('领取失败')
    } finally {
      setLoading(false)
    }
  }
  // 监听 claimed 状态变化，处理领取成功后的自动关闭逻辑
  useEffect(() => {
    // 如果未领取，不执行后续逻辑
    if (!claimed) return;
    
    // 设置 3 秒定时器，自动关闭弹窗
    const timer = setTimeout(() => {
      onClose()        // 调用关闭回调
      setClaimed(false) // 重置领取状态
    }, 3000);
    
    // 清理函数：组件卸载或 claimed 变化时清除定时器，避免内存泄漏
    return () => {
      clearTimeout(timer);
    };
  }, [claimed]); // 依赖项：仅在 claimed 状态变化时触发

  // 条件渲染：未领取且无新人礼包且未在加载中时，不渲染任何内容
  if (!claimed && !showGift && !loading) return null;

  // H5路由使用自己的领取弹窗，不显示PC版
  if (window.location.pathname.startsWith('/h5/')) {
    return null;
  }

  // 渲染欢迎弹窗
  return (
    <WelcomeOverlay>
      {claimed
        ? <ClaimedView count={count} />           // 已领取：显示领取成功视图
        : <GiftView onClose={onClose} onClaim={handleSave} loading={loading}/>
      }
    </WelcomeOverlay>
  )
}
